// extracted by css-extract-rspack-plugin
export default {"auth-tabs__list":"auth-tabs__list___HBBJnUjS","auth-tabs__content":"auth-tabs__content___XTx3_B6m","auth-tabs__trigger":"auth-tabs__trigger___XyCfpmxD"};